import VisitState from './care-planning-app/context/visit/VisitState';
import PPUIInitReactProps from './care-planning-app/PPUIInitReactProps';

/**
 * This component is responsible for getting all the PPUI-related data before rendering
 * PPUI components. It's not truly a provider, but it achieves a similar result.
 *
 * * PPUIInitReactProps gets and sets `window.initReactProps`.
 * * VisitState uses data from `window.initReactProps` to fetches visit state, which is
 * * used for the Patient Care Plan and Encounter Details.
 */
const PPUIProvider = ({children}) => {
    return (
        <PPUIInitReactProps>
            <VisitState>{children}</VisitState>
        </PPUIInitReactProps>
    );
};

export default PPUIProvider;
